import React from 'react';
import { useHistory } from 'react-router-dom';
import { createMarkup, isExternalLink } from '@core/shared-utils';
import classes from './Page.module.scss';

const HTMLBlock = ({ html }) => {
    const history = useHistory();

    const onBodyClick = (event) => {
        const anchor = event.target.closest('a');
        if (anchor) {
            const href = anchor.getAttribute('href');
            if (
                href &&
                !isExternalLink(href) &&
                !href.startsWith('mailto:') &&
                !href.startsWith('tel:') &&
                !href.startsWith('#')
            ) {
                event.preventDefault();
                history.push(href);
            }
        }
    };

    return <div dangerouslySetInnerHTML={createMarkup(html || '')} className={classes.Page} onClick={onBodyClick} />;
};

export default HTMLBlock;
